module.exports = __webpack_public_path__ + "static/img/yjxzLogoN.c9fec72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yjxzLogoN.png
// module id = fakC
// module chunks = 2